import type { DisableRule } from "@/types/validation";

export function resolveDisableRules(rules: DisableRule[]): DisableRule {
  const activeRules = rules.filter((rule) => rule.disabled);

  return {
    disabled: activeRules.length > 0,
    reasons: activeRules.flatMap((rule) => rule.reasons),
  };
}
